module.exports = __webpack_public_path__ + "img/能源管理系统_04.0a9b9fed.png";